import { logDebugging } from '../../log/logger';
import PlaylistDataModel from '../../core/models/playlistDataModel';
import ServiceError from '../../core/errors/ServiceError';
import loadServiceFactory from './loadServiceFactory';
import parserPlaylistFactory from '../parsers/playlist/parserPlaylistFactory';
import videoProducerManager from '../videoproducer/videoProducerManager';
import parserConfigPlayerFactory from '../parsers/configplayer/parserConfigPlayerFactory';
// import { playlistVideoDataResponse } from './dataplaylistexample';

export default async function loadPlayListDataModel(config) {
  // llamada al servicio que nos devuelva los datos del video
  try {
    const jsonToParsed = await loadServiceFactory(config); // playlistVideoDataResponse; //

    logDebugging('jsonContextual', jsonToParsed);
    if (jsonToParsed instanceof ServiceError) {
      throw jsonToParsed;
    }

    const playListDataParsed = parserPlaylistFactory(config, jsonToParsed);
    const configPlayerModel = parserConfigPlayerFactory(config, jsonToParsed);

    logDebugging('playListDataParsed', playListDataParsed);

    const playlistDataModel = new PlaylistDataModel(
      playListDataParsed,
      config.loop,
      jsonToParsed?.company?.id,
    );
    if (playlistDataModel.isVideoProducer()) {
      const videoProducerModel = await videoProducerManager(
        playlistDataModel.videoProducerItem.urlVideoProducer,
      );
      // console.log(videoProducerModel.getUrlVideo());
      playlistDataModel.setUrlVideoForVideoProducer(videoProducerModel.getUrlVideo());
      playlistDataModel.setVideoProducerModel(videoProducerModel);
    }
    return [playlistDataModel, configPlayerModel];
  } catch (error) {
    throw new ServiceError(error.message, error.code);
  }
}
